<template>
  <div class="grid-container">
    <div v-if="viewBreakpointIs('small')" class="my-4">
      <collapse
        icon-active="expand_more"
        icon-inactive="expand_less"
        icon-position="right"
        :default-active="false"
        :accordion="true"
        :value="['login']"
      >
        <collapse-item name="login">
          <div slot="title" class="heading heading--lg">
            {{ bp('login.login') }}
          </div>
          <user-login :base-properties="baseProperties" :options="options" />
        </collapse-item>
        <collapse-item name="register">
          <div slot="title" class="heading heading--lg">
            {{ bp('register.new.customer') }}
          </div>
          <user-register :base-properties="baseProperties" :options="options">
            <template v-slot:privacy-notice>
              <slot name="register-privacy-notice" />
            </template>
          </user-register>
        </collapse-item>
      </collapse>
    </div>
    <div v-else class="flex my-5">
      <div class="w-1/2 border-r border-gray-10">
        <div class="max-w-sm md:mr-2 lg:mx-6">
          <section-header size="xl" class="mb-5">
            <heading level="1" size="xl" v-html="bp('login.login')" />
          </section-header>
          <div class="text-lg font-semibold mb-2" v-html="bp('login.title')" />
          <user-login :base-properties="baseProperties" :options="options" />
        </div>
      </div>
      <div class="w-1/2">
        <div class="max-w-sm md:ml-2 lg:mx-6">
          <section-header size="xl" class="mb-5">
            <heading level="1" size="xl" v-html="bp('register.new.customer')" />
          </section-header>
          <div class="text-lg font-semibold mb-2" v-html="bp('guest.checkout')" />
          <user-register :base-properties="baseProperties" :options="options">
            <template v-slot:privacy-notice>
              <slot name="register-privacy-notice" />
            </template>
          </user-register>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Heading from '@/components/Heading';
import Collapse from '@/components/Collapse';
import CollapseItem from '@/components/CollapseItem';
import SectionHeader from '@/components/SectionHeader';
import UserLogin from '@/components/containers/my-account/UserLogin';
import UserRegister from '@/components/containers/my-account/UserRegister';
import {UserAccountBase} from '@/components/containers/my-account/utils/user-account-base';
import viewSize from '@/mixins/view-size';

export default {
  name: 'LoginContainer',
  components: {Heading, Collapse, CollapseItem, SectionHeader, UserRegister, UserLogin},
  extends: UserAccountBase,
  mixins: [viewSize],
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoginVisible: true,
    };
  },
};
</script>
